<template lang="pug">
  v-row.list-view-module(
    v-if="currentItems"
  )
    //- Left side
    v-col.fill-height(xl=3 lg=4 cols=12)
      v-card.list-view-module__left-sidebar(
        flat
        tile
      )
        .monkey-container
          v-text-field.pa-2(
            v-model="searchQuery"
            filled
            dense
            rounded
            append-icon="mdi-magnify"
            label="Поиск"
            hide-details
          )
        v-list(nav).scrollable-menu
          v-list-item.ma-0.pa-0(
            v-for="item in currentItems"
            :key="item.id"
            @click="showItemContent(item)"
            :input-value="currentItem && currentItem.id === item.id"
            color="primary"
          )
            v-list-item-avatar
              v-icon {{ instructionTypesIcons[item.type] }}
            v-list-item-content {{ item.name }}

    //- Right side
    //- Desktop
    v-col.list-view-module__scrollable(xl=9 lg=8 v-if="!breakpoint.mdAndDown")
      .list-view-module__right-sidebar(v-if="currentItem" flat height="100%" tile)
        instruction-list-item(:current-item="currentItem")

    //- Tablet & Mobile
    v-col(cols=12 v-else)
      v-bottom-sheet(
        v-model="rightSideSheet"
        scrollable
      )
        v-card.overflow-scroll.pa-2.list-view-module__right-sidebar(v-if="currentItem" flat)
          instruction-list-item(:current-item="currentItem")
</template>

<script>
import InstructionListItem from './InstructionListItem.vue';

import Constants from '../constants';

export default {
  name: 'InstructionList',
  components: {
    InstructionListItem,
  },
  props: {
    selectFirst: {
      type: Boolean,
      default: false,
    },
    showItem: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      searchQuery: '',
      currentItems: null,
      currentItem: null,
      scrollTopPosition: 0,
      rightSideSheet: false,
      instructions: [],
      systemId: 3,
      instructionTypesIcons: Constants.INSTRUCTIONS_TYPES_ICONS,
    };
  },
  computed: {
    breakpoint() {
      return this.$vuetify.breakpoint;
    },
  },
  watch: {
    instructions(values) {
      this.currentItems = values;

      if (this.selectFirst && !this.breakpoint.mdAndDown) {
        this.setFirstItem();
      }
    },
    breakpoint: {
      handler(value) {
        if (value.mdAndUp) {
          if (this.selectFirst && this.currentItems) {
            this.setFirstItem();
          }
        }
        if (value.mdAndDown) {
          this.currentItem = null;
        }
      },
      immediate: true,
      deep: true,
    },
    searchQuery(value) {
      if (value) {
        const regexp = new RegExp(`${value}`, 'gmi');
        this.currentItems = this.instructions.filter((item) => regexp.exec(item.name));
      } else {
        const baseItems = this.instructions;
        this.currentItems = baseItems;
      }
    },
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      await this.getInstructions();

      if (this.showItem) {
        const currentItem = this.instructions.find((i) => i.id === this.showItem);
        this.showItemContent(currentItem);
      }
    },
    showItemContent(newItem) {
      this.currentItem = newItem;

      if (this.breakpoint.mdAndDown) {
        this.rightSideSheet = true;
      }
    },
    setFirstItem() {
      const [firstItem] = this.instructions;
      this.currentItem = firstItem;
    },
    getInstructions() {
      const Roles = {
        1: 'certificate',
        2: 'pedagogue',
        3: 'organizations',
      };
      const queryParams = {
        'search[system_id]': this.systemId,
        'search[role_name]': Roles[this.$user.data.role],
        expand: 'role_name',
      };

      return this.$api.dir.getInstructions(queryParams)
        .then((response) => {
          this.instructions = response.data.data;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
  ::v-deep {
    span {
      line-height: 1.5;
    }

    img {
      max-width: 100% !important;
      height: auto !important;
    }

    ul {
      margin-bottom: 1em;

      li {
        margin: 0.5em 0;
      }
    }
  }

  .overflow-scroll {
    overflow: scroll;
  }

  .list-view-module {
    // flex-direction: column;
    min-height: 500px;
    height: 100%;
    overflow: hidden;

    &__scrollable {
      flex: 1 1 100%;
      overflow: scroll;

    }

    &__right-sidebar {

      .v-card__text {
        height: 100% !important;
        padding: 32px !important;
      }
    }
    &__left-sidebar {
      display: flex;
      height: 100%;
      flex-direction: column;

      .scrollable-menu {
        overflow: scroll;
      }
    }

    ::-webkit-scrollbar {
      width: 14px;

      &-thumb {
        width: 6px;
        border: 4px solid rgba(0, 0, 0, 0);
        background-clip: padding-box;
        border-radius: 7px;
        background-color: #E0E0E0;
      }

      &-button {
        width: 0;
        height: 0;
        display: none;
      }

      &-corner {
        background-color: transparent;
      }
    }
  }

  .v-dialog > .v-card.list-view-module__right-sidebar > .v-card__text {
    overflow-x: hidden !important;
    height: 100% !important;
    padding: 32px !important;
  }
</style>
